<div class="container-news bg-neutral-95 no-print" *ngIf="block"
    [ngStyle]="{'margin-top': this.block.bundle === 'blocco_tutte_le_news' ? '0px' : '48px'}">
    <div class="container">
        <app-header-event [headerData]="headerData">
        </app-header-event>
        <!-- DESKTOP -->
        <div class="d-none d-md-block" *ngIf="newsDataArrayBig && newsDataArraySmall && newsDataArraySmall.length">
            <app-sample-news-big [dataNews]="newsDataArrayBig"></app-sample-news-big>
            <div class="d-flex justify-content-between align-items-stretch w-100 h-100 mt-3">
                <ng-container *ngFor="let dataNewsSmall of newsDataArraySmall; let idx = index;">
                    <div class="col-4">
                        <app-sample-news-small [dataNews]="dataNewsSmall" [isMobile]="false"></app-sample-news-small>
                    </div>
                </ng-container>
            </div>
        </div>
        <!-- END DESKTOP -->
        <!-- MOBILE -->
        <div class="d-block d-md-none">
            <ng-container *ngIf="newsDataArrayAll && newsDataArrayAll.length">
                <owl-carousel-o [options]="customOptionsNews" id="carousel-last-news">
                    <ng-container *ngFor="let dataNews of newsDataArrayAll; let idx = index;">
                        <ng-template carouselSlide>
                            <div class="p-2 w-100">
                                <app-sample-news-small [dataNews]="dataNews" [isMobile]="true"></app-sample-news-small>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </ng-container>
            <div *ngIf="headerData" class="mt-3">
                <a *ngIf="!nodeService.verifyLinkExternal(headerData.labelLinkUrl) && headerData.labelLink"
                    [routerLink]="navigationService.splitUrlRouterLink(headerData.labelLinkUrl).path" [queryParams]="navigationService.splitUrlRouterLink(headerData.labelLinkUrl).queryParams">
                    <button class="btn-header-news-custom w-100 ls-label-small-semibold"
                        [innerHTML]="headerData.labelLink"></button>
                </a>
                <a *ngIf="nodeService.verifyLinkExternal(headerData.labelLinkUrl) && headerData.labelLink"
                    [href]="headerData.labelLinkUrl">
                    <button class="btn-header-news-custom w-100 ls-label-small-semibold"
                        [innerHTML]="headerData.labelLink"></button>
                </a>
            </div>
        </div>
        <!-- END MOBILE -->
    </div>
</div>
<div class="card-event-no-print w-100">
    <ng-container *ngFor="let news of allNews">
        <app-sample-print
            [imageUrl]="news.field_immagine ? domainWebsite + nodeService.retrieveImage(news.field_immagine, 'src') : ''" 
            [date]="news.field_created_at" 
            [title]="nodeService.retriveLinkTagA(news.field_titolo, 'a').title" 
            [taxonomies]="news.field_tassonomia_area_universita">
        </app-sample-print>
    </ng-container>
</div>